"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "fixed z-50 left-4 bottom-4 gap-3 flex flex-col" };
const Alerts_1 = require("../../stores/Alerts");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AlertTester',
    setup(__props) {
        const store = (0, Alerts_1.useAlertsStore)();
        function addAlert(type, message, url = null) {
            store.add({
                type,
                message,
                time: 10000,
                key: type !== null && type !== void 0 ? type : 'info',
                url,
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("button", {
                    class: "button button-red-500 text-white hover:bg-red-600",
                    onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (addAlert('error', 'Something went wrong')), ["prevent"]))
                }, " Error "),
                (0, vue_2.createElementVNode)("button", {
                    class: "button button-green-500 text-white hover:bg-green-600",
                    onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (addAlert('success', 'Something went right')), ["prevent"]))
                }, " Success "),
                (0, vue_2.createElementVNode)("button", {
                    class: "button button-yellow-500 text-mutedpurple-800 hover:bg-yellow-600",
                    onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (addAlert('warning', 'Something went ok-ish')), ["prevent"]))
                }, " Warning "),
                (0, vue_2.createElementVNode)("button", {
                    class: "button button-teal-500 text-white hover:bg-teal-600",
                    onClick: _cache[3] || (_cache[3] = (0, vue_2.withModifiers)(($event) => (addAlert('info', 'Something happened')), ["prevent"]))
                }, " Info "),
                (0, vue_2.createElementVNode)("button", {
                    class: "button button-mutedpurple-800 text-white hover:bg-mutedpurple-900",
                    onClick: _cache[4] || (_cache[4] = (0, vue_2.withModifiers)(($event) => (addAlert('link', 'This one is clickable', '/basket')), ["prevent"]))
                }, " Link ")
            ]));
        };
    }
});
